// Full-page screen shown when the org's IP allowlist blocks this network
// (PLO-5010). It replaces the whole portal rather than rendering inside it:
// every authenticated request is 403ing, so the shell around it would be empty
// chrome over nothing, and the nav's own queries would keep retrying.
//
// The copy has to answer the only question the employee can act on — "what do
// I do now?" — so it names the two fixes (company network / VPN) and who to
// ask. It deliberately does not name the allowed ranges: the employee can't do
// anything with them and they're the org's security posture.

import { Flex } from "@chakra-ui/react";
import { TbShieldLock } from "react-icons/tb";
import { EmptyState, PloyButton } from "./ds";

const IpRestrictedScreen = () => (
  <Flex w="100vw" h="100vh" justify="center" align="center">
    <EmptyState
      icon={<TbShieldLock />}
      title="You're not on an approved network"
      body="Your organisation only allows Ploy to be opened from its approved networks. Connect to your company network or VPN and try again. If you think this is a mistake, contact your IT team."
      action={
        <PloyButton
          variant="secondary"
          size="sm"
          onClick={() => window.location.reload()}
        >
          Try again
        </PloyButton>
      }
    />
  </Flex>
);

export default IpRestrictedScreen;
